export default "__VITE_ASSET__DgBGAMQM__"